module.exports = __webpack_public_path__ + "img/Logo-Dark.fd2473ac.svg";